import {Spinner, SpinnerSize, Tab} from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useApiEffect } from "nsitools-react";
import { HealthPackApi } from "../../../../api";
import { HealthPackDetailPage } from "./HealthPackDetailPage";

export interface IHealthPackItemPageProps {}

export const HealthPackItemPage: React.FunctionComponent<IHealthPackItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(HealthPackApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Packs), route: ERoutes.healthPack },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsHealthPacks"
        onChange={(newTabId) => history.push(`${ERoutes.healthPack}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.healthPack} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<HealthPackDetailPage healthPackId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
